module.exports = __webpack_public_path__ + "img/logo-artrade2.8f5a1c6d.png";